import React from 'react';
import queryString from 'query-string';
import { Route } from 'react-router-dom';
import { AuthLayout } from '../../modules/theme';
import {
  SignIn,
  ForgotPassword,
  ResetPassword,
  TenantSignIn,
  AdminLogin
} from './components';
import Otp from './components/Otp';
import SignUp from './components/SignUp';
import FinalSignUp from './components/FinalSignUp';

const routes = () => [
  <Route
    path="/admin"
    key="admin"
    component={() => {
      return (
        <AuthLayout content={<SignIn />} type="admin" background="admin" />
      );
    }}
  />,
  <Route
    path="/sign-in"
    key="signIn"
    component={() => {
      return (
        <AuthLayout content={<TenantSignIn />} type="TenantSignIn" background="TenantSignIn" />
      );
    }}
  />,
  <Route
    path="/tenant-signin"
    key="tenantSignIn"
    component={() => {
      return (
        <AuthLayout
          content={<TenantSignIn />}
          type="TenantSignIn"
          background="TenantSignIn"
        />
      );
    }}
  />,
  <Route
    path="/signup"
    key="signup"
    component={() => {
      return (
        <AuthLayout content={<SignUp />} type="signup" background="signup" />
      );
    }}
  />,

  <Route
    path="/sign-up"
    key="sign-up"
    component={() => {
      return <AuthLayout content={<FinalSignUp />} />;
    }}
  />,

  <Route
    path="/otp"
    key="otp"
    component={() => {
      return <AuthLayout content={<Otp />} />;
    }}
  />,

  <Route
    path="/forgot-password"
    key="forgotPassword"
    component={() => {
      return <AuthLayout content={<ForgotPassword />} />;
    }}
  />,

  <Route
    path="/reset-password"
    key="resetPassword"
    component={({ location }) => {
      const parsed = queryString.parse(location.search);
      return <AuthLayout content={<ResetPassword token={parsed.token} />} />;
    }}
  />
];

export default routes;



// WEBPACK FOOTER //
// ./src/modules/auth/routes.js